/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AppUpdateUserLastLoginMutationVariables = {|
  userEmail: string
|};
export type AppUpdateUserLastLoginMutationResponse = {|
  +updateUserLastLogin: ?{|
    +status: ?string
  |}
|};
export type AppUpdateUserLastLoginMutation = {|
  variables: AppUpdateUserLastLoginMutationVariables,
  response: AppUpdateUserLastLoginMutationResponse,
|};
*/


/*
mutation AppUpdateUserLastLoginMutation(
  $userEmail: String!
) {
  updateUserLastLogin(userEmail: $userEmail) {
    status
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userEmail"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userEmail",
        "variableName": "userEmail"
      }
    ],
    "concreteType": "Status",
    "kind": "LinkedField",
    "name": "updateUserLastLogin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppUpdateUserLastLoginMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppUpdateUserLastLoginMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "097b941a44b9e74fe43a52d70a9b55aa",
    "id": null,
    "metadata": {},
    "name": "AppUpdateUserLastLoginMutation",
    "operationKind": "mutation",
    "text": "mutation AppUpdateUserLastLoginMutation(\n  $userEmail: String!\n) {\n  updateUserLastLogin(userEmail: $userEmail) {\n    status\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd4b717555ffedcb5123e0edb632468eb';

module.exports = node;
